import { ActionRequiredType } from '@/interfaces';

export const getActionRequiredPrefixByType = (type: string): string => {
	const prefixMap: Record<ActionRequiredType, string> = {
		APPROVAL: 'Confirm if the',
		OPT_OUT: 'Accept',
		COMPLAINT: '',
		DOCUMENT: 'Upload',
		FOLLOW_UP_DOCUMENT: 'Answer',
		FORM: 'Clarify',
		SETTLEMENT_WITH_SIGN: 'Confirm',
		SETTLEMENT_WITHOUT_SIGN: 'Confirm',
		PROVIDE_PAYMENT: 'Provide',
		CONFIRM_PAYMENT: 'Confirm',
		RETAINER: 'Review & Sign',
		COMPLETE_PROFILE: '',
		SIGNATURE: 'Review & Sign',
		PAYMENT_WITH_SIGN: '', //Not implemented
		PAYMENT_WITHOUT_SIGN: '', //Not implemented
		REQUESTED_DOCUMENT: '', //Not implemented,
		FOLLOW: 'Answer',
	};

	return prefixMap[type as keyof typeof prefixMap] || ''; // default empty string
};

export const getActionRequiredComplementByType = (type: string): string => {
	const complementMap: Record<string, string> = {
		APPROVAL: 'is acceptable',
		SETTLEMENT_WITH_SIGN: '',
		SETTLEMENT_WITHOUT_SIGN: '',
	};

	return complementMap[type] || ''; // default empty string
};
